var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 56 64",
    enableBackground: "new 0 0 56 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C8CEA",
    d: "M5.1,0C2.3,0,0,2.3,0,5.1v53.8C0,61.7,2.3,64,5.1,64h45.8c2.8,0,5.1-2.3,5.1-5.1V20.3L37.1,0 C37.1,0,5.1,0,5.1,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2D6FE4",
    d: "M56,20.4v1H43.2c0,0-6.4-1.3-6.2-6.7c0,0,0.2,5.7,6,5.7H56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M37.1,0v14.6c0,1.6,1.1,5.8,6.1,5.8H56C56,20.4,37.1,0,37.1,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.9,45.1h-7.6v2.2h5.4c-0.3,3.2-2.9,4.5-5.4,4.5c-3.2,0-5.9-2.5-5.9-6c0-3.4,2.6-6,5.9-6 c2.5,0,4.1,1.6,4.1,1.6l1.6-1.6c0,0-2-2.2-5.7-2.2c-4.7,0-8.3,4-8.3,8.2c0,4.2,3.4,8.3,8.4,8.3c4.4,0,7.7-3,7.7-7.5 C26,45.7,25.9,45.1,25.9,45.1L25.9,45.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdocs);
export default __webpack_public_path__ + "static/media/gdocs.fef51a3df1dcdbd70ce7290841688008.svg";
export { ForwardRef as ReactComponent };